export const MAIN_ACTION = {
  CHANGE_STATE: 'MAIN_ACTION_CHANGE_STATE',
  RESET_STATE: 'MAIN_ACTION_RESET_STATE',

  GET_STAKING_DATA: 'MAIN_ACTION_GET_STAKING_DATA',
  GET_STAKING_DATA_SUCCESS: 'MAIN_ACTION_GET_STAKING_DATA_SUCCESS',
  GET_STAKING_DATA_FAILED: 'MAIN_ACTION_GET_STAKING_DATA_FAILED',

  CLAIM_STAKING: 'MAIN_ACTION_CLAIM_STAKING',
  CLAIM_STAKING_SUCCESS: 'MAIN_ACTION_CLAIM_STAKING_SUCCESS',
  CLAIM_STAKING_FAILED: 'MAIN_ACTION_CLAIM_STAKING_FAILED',

  CLAIM_TAP: 'MAIN_ACTION_CLAIM_TAP',
  CLAIM_TAP_SUCCESS: 'MAIN_ACTION_CLAIM_TAP_SUCCESS',
  CLAIM_TAP_FAILED: 'MAIN_ACTION_CLAIM_TAP_FAILED'
}
